import { Box } from '@wix/design-system';
import { NavigationButton } from '@wix/premium-purchase-platform/@ui';
import { ChevronLeftSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

const BACK_BUTTON_TOP = 25;
const PAGE_GUTTER = 48;

interface NavigateBackProps {
  onBack: () => void;
}

export const NavigateBack = ({ onBack }: NavigateBackProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <Box width="100%" position="relative">
      <NavigationButton
        onClick={onBack}
        direction="back"
        isVisible={true}
        alwaysShowText={true}
        icon={<ChevronLeftSmall />}
        top={BACK_BUTTON_TOP}
        left={PAGE_GUTTER}
        text={t('premium-purchase-plan.eclipse.back.cta')}
      />
    </Box>
  );
};
